import React from 'react';
import { FormInputRadio } from '../../../common/formInputs/FormInputRadio';
import { flagResponse } from '../../../common/constants';
import { FormInputText } from '../../../common/formInputs/FormInputText';

const questions = {
  in_good_condition: {
    label: 'Sei interessato alla copertura eventi catastrofali fabbricato?',
    name: 'catastrophic_building_coverage',
    value_name: 'catastrophic_building_coverage_value',
    value_label: 'Somma assicurata eventi catastrofali fabbricato (€)',
    disable: true,
    value_type: 'number',
  },
  has_building_violation: {
    label:
      'Sei interessato alla copertura eventi catastrofali - contenuto “impianti e macchinari”  ?',
    name: 'catastrophic_content_machinery_coverage',
    value_name: 'catastrophic_content_machinery_coverage_value',
    value_label:
      'Somma assicurata eventi catastrofali contenuto “impianti e macchinari”  (€)',
    value_type: 'number',
  },
  under_construction: {
    label:
      'Sei interessato alla copertura eventi catastrofali - contenuto “attrezzature industriali e commerciali” ?',
    name: 'catastrophic_content_equipment_coverage',
    value_name: 'catastrophic_content_equipment_coverage_value',
    value_label:
      'Somma assicurata eventi catastrofali - contenuto “attrezzature industriali e commerciali”  (€)',
    value_type: 'number',
  },
  catastrophic_land_coverage: {
    label: 'Sei interessato alla copertura eventi catastrofali terreno?',
    name: 'catastrophic_land_coverage',
    value_name: 'catastrophic_land_coverage_value',
    value_label: 'Superfice del terreno in metri quadrati (m2)',
    value_type: 'number',
  },
};
function CommercialCatastropheContractorCoverage({
  errors,
  isValid,
  register,
  answers,
}) {
  return (
    <>
      <h4 className="text-center mt-3">Coperatura</h4>
      <div className="row mt-5 d-flex justify-content-center">
        <div className="col-12">
          <div className="card border">
            <div className="card-body">
              <div className="col-12">
                <div className="d-flex flex-column align-items-center justify-content-center gap-5">
                  {Object.values(questions).map((question, index) => (
                    <div key={index}>
                      <FormInputRadio
                        label={question.label}
                        options={flagResponse}
                        name={question.name}
                        error={errors?.coverage?.[question.name]?.message}
                        disabled={question.disable}
                        valid={isValid(`coverage.${question.name}`)}
                        registration={register(`coverage.${question.name}`)}
                      />
                      {answers?.coverage?.[question.name] == '1' && (
                        <FormInputText
                          label={question.value_label}
                          name={question.value_name}
                          type={question.value_type}
                          error={
                            errors?.coverage?.[question.value_name]?.message
                          }
                          valid={isValid(`coverage.${question.value_name}`)}
                          registration={register(
                            `coverage.${question.value_name}`,
                          )}
                        />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CommercialCatastropheContractorCoverage;
